import React, {Component} from 'react';
import {SingleDatePicker} from "react-dates";
import moment from 'moment';
import CalendarView from "./components/CalendarView";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import "../../../css/pages/admin/components/CalendarView.css";
import {GetWithAuth} from "../../api/client/Get";
import {Loadable} from "../Loadable";


class AdminCalendar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            date: moment(),
            focused: false,
            value: 1,
            monthData: [],
            loading: false
        };
    }

    componentWillMount() {
        this.getData();
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue + 1
        }, () => this.getData());
    };

    getData = () => {
        let roomId = this.state.value;

        this.setState({
            monthData: [],
            loading: true
        }, () => {
            GetWithAuth("/api/admin/calendar/" + roomId + "?start=" + this.getDate(), this.props.token)
                .then(res => {
                    this.setState({
                        monthData: res.data,
                        loading: false
                    })
            });
        });
    };

    getDate = () => {
        return this.state.date.format("YYYY-MM");
    };

    handleDateChange = (date) => {
        this.setState({
            date: date
        }, () => this.getData());
    };

    render() {
        return (
            <div>
                <div style={{width: "100%"}}>
                    <SingleDatePicker
                        date={this.state.date}
                        onDateChange={date => this.handleDateChange(date)}
                        focused={this.state.focused}
                        onFocusChange={({focused}) => this.setState({focused})}
                        id="admin_date_picker"
                    />
                </div>

                <AppBar position={"static"} id={"calendar_picker"} style={{marginTop: '15px'}}>
                    <Tabs value={this.state.value - 1} onChange={this.handleChange}>
                        <Tab label="Room 1"/>
                        <Tab label="Room 2"/>
                        <Tab label="Room 3"/>
                        <Tab label="Room 4"/>
                        <Tab label="Room 5"/>
                    </Tabs>
                </AppBar>
                <br/>
                <Loadable loading={this.state.loading}>
                    <CalendarView token={this.props.token}
                                  roomId={this.state.value}
                                  monthData={this.state.monthData}
                    />
                </Loadable>
            </div>
        );
    }
}

export default AdminCalendar;